// extracted by mini-css-extract-plugin
export default {"emptyCart":"EmptyCart_emptyCart__F4OwG","title":"EmptyCart_title__ZQqJ6","subtitle":"EmptyCart_subtitle__9o-xz","icon":"EmptyCart_icon__NoF7X","button":"EmptyCart_button__kOGCM"};